import baseApi from './base.api'
import {
    onCreateOrganizationLmsConfigQueryStarted,
    onExportLmsSubmissionsQueryStarted,
    onImportLmsSubmissionsQueryStarted,
    onUpdateAssignmentLmsConfigStarted,
} from './utils/response-handlers/lms.api.response-handlers'
import {
    denormalizeUpdateLmsQuestionsRelationshipsPayload,
    normalizeFetchLmsConfigResponse,
    normalizeFetchLmsConfigsResponse,
    normalizeFetchLmsQuestionsResponse,
} from './utils/normalizers/lms.normalizers'
import { LMS_QUESTIONS_TAG } from './utils/tags'

export const lmsApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        fetchLmsConfigs: builder.query({
            query: () => ({
                url: `/lms/config/all`,
                method: 'GET',
            }),
            transformResponse: normalizeFetchLmsConfigsResponse,
        }),
        fetchLmsConfig: builder.query({
            query: ({ organizationId }) => ({
                url: organizationId ? `/lms/config/${organizationId}` : '/lms/config',
                method: 'GET',
            }),
            transformResponse: normalizeFetchLmsConfigResponse,
        }),
        updateOrganizationLmsConfig: builder.mutation({
            query: ({ organizationId, lmsUrl, token }) => ({
                url: organizationId ? `/lms/config/${organizationId}` : '/lms/config',
                method: 'PUT',
                body: {
                    lms_url: lmsUrl,
                    token,
                },
            }),
            onQueryStarted: onCreateOrganizationLmsConfigQueryStarted,
        }),
        updateAssignmentLmsConfig: builder.mutation({
            query: ({ assignmentToken, courseId, quizId, enabled }) => ({
                url: `/lms/config/assignment/${assignmentToken}`,
                method: 'PUT',
                body: {
                    lms_course_id: courseId,
                    lms_quiz_id: quizId,
                    lms_enabled: enabled,
                },
            }),
            onQueryStarted: onUpdateAssignmentLmsConfigStarted,
        }),
        importLmsSubmissions: builder.mutation({
            query: ({ assignmentToken, otp }) => ({
                url: `/lms/import-submissions/${assignmentToken}`,
                method: 'POST',
                params: {
                    otp,
                },
            }),
            onQueryStarted: onImportLmsSubmissionsQueryStarted,
        }),
        exportLmsSubmissions: builder.mutation({
            query: ({ assignmentToken, otp }) => ({
                url: `/lms/send-grades/${assignmentToken}`,
                method: 'POST',
                params: {
                    otp,
                },
            }),
            onQueryStarted: onExportLmsSubmissionsQueryStarted,
        }),
        fetchLmsQuestions: builder.query({
            query: ({ assignmentToken }) => ({
                url: `/lms/config/assignment/${assignmentToken}/patterns`,
                method: 'GET',
            }),
            transformResponse: normalizeFetchLmsQuestionsResponse,
            providesTags: [LMS_QUESTIONS_TAG],
        }),
        updateLmsQuestionsRelationships: builder.mutation({
            query: ({ assignmentToken, questionsRelationships }) => {
                return {
                    url: `/lms/config/assignment/${assignmentToken}/patterns`,
                    method: 'PUT',
                    body: denormalizeUpdateLmsQuestionsRelationshipsPayload(questionsRelationships),
                }
            },
            invalidatesTags: [LMS_QUESTIONS_TAG],
        }),
    }),
})

export const {
    useFetchLmsConfigsQuery,
    useFetchLmsConfigQuery,
    useUpdateOrganizationLmsConfigMutation,
    useUpdateAssignmentLmsConfigMutation,
    useImportLmsSubmissionsMutation,
    useExportLmsSubmissionsMutation,
    useFetchLmsQuestionsQuery,
    useUpdateLmsQuestionsRelationshipsMutation,
} = lmsApi
